export const backendApiTestsStyles: Record<string, React.CSSProperties> = {
  testWorkspace: {
    display: "grid",
    gap: 16,
    marginTop: 18,
  },
  testTabs: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: 8,
  },
  testTab: {
    display: "grid",
    gap: 2,
    padding: "10px 12px",
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    background: "var(--color-bg)",
    textAlign: "left",
    color: "var(--color-text)",
  },
  testTabActive: {
    borderColor: "var(--color-primary)",
    background: "#eff6ff",
  },
  fileBrowserShell: {
    display: "grid",
    gridTemplateColumns: "420px minmax(0, 1fr)",
    gap: 16,
    alignItems: "start",
  },
  fileIndexPanel: {
    position: "sticky",
    top: 16,
    maxHeight: "calc(100vh - 48px)",
    overflow: "auto",
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    padding: 12,
    background: "var(--color-bg)",
  },
  fileList: {
    display: "grid",
    gap: 6,
    marginTop: 10,
  },
  fileIndexLink: {
    display: "grid",
    gap: 3,
    padding: "8px 10px",
    border: "1px solid transparent",
    borderRadius: 6,
    color: "var(--color-text)",
  },
  fileIndexLinkActive: {
    borderColor: "var(--color-primary)",
    background: "#eff6ff",
  },
  fileDetailHeader: {
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
    alignItems: "flex-start",
  },
  filePathTitle: {
    margin: 0,
    fontFamily: "var(--font-mono)",
    fontSize: 18,
    overflowWrap: "anywhere",
  },
  fileStats: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    color: "var(--color-text-secondary)",
    fontSize: 12,
  },
  detailTabs: {
    display: "flex",
    gap: 8,
  },
  detailTab: {
    padding: "6px 12px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  detailTabActive: {
    borderColor: "var(--color-primary)",
    background: "#eff6ff",
  },
  fileTestList: {
    display: "grid",
    gap: 10,
  },
  testCaseCard: {
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    padding: 12,
    background: "var(--color-bg)",
  },
  testCaseHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
  },
  testCaseTitle: {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.4,
  },
  errorNote: {
    padding: "8px 10px",
    border: "1px solid var(--color-danger-bg)",
    borderRadius: 6,
    background: "var(--color-danger-bg)",
    color: "var(--color-danger)",
  },
};
